import React from "react";
import FormField from "@adsk/alloy-react-form-field";
import TextInput from "@adsk/alloy-react-text-input";
import { BANNER_VARIANTS } from "@adsk/alloy-react-banner";
import { useTranslations } from "../../utils";
import { BannerError, SubmitError } from "../../shared/types";
import {
  ErrorBannerProjectCreate,
  FormFieldSpacer,
  FromProjectDetailsDivider,
} from "../../shared/SharedDataInputModal.styles";
import { FromProjectDetails } from "../../shared/components/FromProjectDetails";
export var ProjectTemplateCreateInSettingsDataInputModal = function (_a) {
  var account = _a.account,
    isSubmitting = _a.isSubmitting,
    isErrorOpen = _a.isErrorOpen,
    name = _a.name,
    onNameChange = _a.onNameChange,
    onErrorClose = _a.onErrorClose,
    project = _a.project,
    sumbitError = _a.sumbitError,
    bannerError = _a.bannerError;
  // Configure translations
  var T = useTranslations().T;
  // Configure error message
  var inputErrorMessage;
  switch (sumbitError) {
    case SubmitError.DuplicateName:
      inputErrorMessage = T.translate("errors.duplicateName");
      break;
    case SubmitError.InvalidName:
      inputErrorMessage = T.translate("errors.invalidName");
      break;
    case SubmitError.NameTooLong:
      inputErrorMessage = T.translate("errors.nameTooLong");
      break;
    case SubmitError.Other:
      inputErrorMessage = T.translate("errors.other");
      break;
  }
  var creationErrorMessage;
  switch (bannerError) {
    case BannerError.Name:
      creationErrorMessage = T.translate("creationErrors.name");
      break;
    case BannerError.Other:
      creationErrorMessage = T.translate("creationErrors.other");
      break;
  }
  return React.createElement(
    "div",
    { "data-testid": "CreateTemplateInSettingsModal.DataInput" },
    React.createElement(FromProjectDetails, null),
    React.createElement(FromProjectDetailsDivider, null),
    isErrorOpen &&
      React.createElement(ErrorBannerProjectCreate, {
        "data-testid": "CreateTemplateInSettingsModal.Error",
        message: creationErrorMessage,
        variant: BANNER_VARIANTS.ERROR,
        open: isErrorOpen,
        inline: true,
        onClose: onErrorClose,
      }),
    React.createElement(
      FormField,
      {
        "data-testid": "CreateTemplateInSettingsModal.Account.Label",
        label: T.translate("genericStrings.account"),
        labelVariant: FormField.LABEL_VARIANTS.TOP,
      },
      React.createElement(
        "div",
        { "data-testid": "CreateTemplateInSettingsModal.Account.Name" },
        account.name
      )
    ),
    React.createElement(
      FormFieldSpacer,
      null,
      React.createElement(
        FormField,
        {
          "data-testid": "CreateTemplateInSettingsModal.Project.Label",
          label: T.translate("genericStrings.project"),
          labelVariant: FormField.LABEL_VARIANTS.TOP,
        },
        React.createElement(
          "div",
          { "data-testid": "CreateTemplateInSettingsModal.Project.Name" },
          project.name
        )
      )
    ),
    React.createElement(
      FormFieldSpacer,
      null,
      React.createElement(
        FormField,
        {
          "data-testid": "CreateTemplateInSettingsModal.TemplateName.Label",
          error: inputErrorMessage || undefined,
          errorVariant: FormField.ERROR_VARIANTS.CAPTION,
          label: T.translate("createTemplateModal.templateNameLabel"),
          required: true,
          labelVariant: FormField.LABEL_VARIANTS.TOP,
        },
        React.createElement(TextInput, {
          "data-testid": "CreateTemplateInSettingsModal.TemplateName.Input",
          value: name,
          onChange: function (e) {
            return onNameChange(e.target.value);
          },
          disabled: isSubmitting,
        })
      )
    )
  );
};
